var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208008 8.45762C0.208008 4.24108 3.73157 0.833008 7.99367 0.833008C12.2678 0.833008 15.7913 4.24108 15.7913 8.45762C15.7913 10.5824 15.0186 12.555 13.7467 14.227C12.3436 16.0712 10.6142 17.6781 8.66751 18.9394C8.22198 19.2309 7.81989 19.2529 7.33092 18.9394C5.37318 17.6781 3.64375 16.0712 2.25263 14.227C0.979826 12.555 0.208008 10.5824 0.208008 8.45762ZM5.42764 8.6955C5.42764 10.108 6.58028 11.219 7.99359 11.219C9.40781 11.219 10.5716 10.108 10.5716 8.6955C10.5716 7.29396 9.40781 6.12891 7.99359 6.12891C6.58028 6.12891 5.42764 7.29396 5.42764 8.6955Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location_marker.7dd899b218e45620af3387c55e38c9e1.svg";
export { ForwardRef as ReactComponent };